import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { ScheduleType } from "@common/types/domains/accounting/schedule";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { getApiErrorMessage } from "@api/apiError";
import { useMarkScheduleUnbilledMutation } from "@api/scheduleBilling.api";
import {
    SCHEDULE_MARKED_UNBILLED_TOAST,
    buildMarkUnbilledCopy,
} from "./scheduleBillingCopy";
import { SCHEDULE_OPTIONS_BACK_LABEL } from "../options/ScheduleOptionsModal";
import { ScheduleBillingTarget } from "./scheduleBillingRowHelpers";

interface ScheduleMarkUnbilledModalProps {
    target: ScheduleBillingTarget | null;
    onHide: () => void;
}

export const ScheduleMarkUnbilledModal = ({
    target,
    onHide,
}: ScheduleMarkUnbilledModalProps) => {
    const { toast, error } = useToaster();
    const mutation = useMarkScheduleUnbilledMutation();

    const handleConfirm = async () => {
        if (!target) {
            return;
        }
        try {
            await mutation.mutateAsync({
                applicationId: target.applicationId,
                entityId: target.entityId,
            });
            toast(SCHEDULE_MARKED_UNBILLED_TOAST, undefined, {
                variant: "success",
            });
            onHide();
        } catch (mutationError) {
            error(
                getApiErrorMessage(
                    mutationError,
                    "Failed to mark the schedule as unbilled",
                ),
            );
        }
    };

    const copy = buildMarkUnbilledCopy(
        target?.billing.scheduleType ?? ScheduleType.revenue,
    );

    return (
        <ConfirmationModal
            show={target !== null}
            title={copy.title}
            question={copy.body}
            yes={copy.confirmLabel}
            yesBtnVariant="primary"
            no={SCHEDULE_OPTIONS_BACK_LABEL}
            onConfirm={handleConfirm}
            onReject={onHide}
            onHide={onHide}
        />
    );
};
